import { Map } from 'immutable';
import TableEditor from './component';

const TableEditorFactory = ({
  identifier,
  dataRenderComponent,
  config,
  data,
}) => ({
  blockRenderMap: Map({
    [`${identifier}`]: {
      element: 'div',
      editable: false,
      isBlockTypeMutable: false,
      fixed: false,
    },
  }),
  blockRendererFn: (
    block,
    { getProps, setEditorState, getEditorState, getReadOnly },
  ) => {
    const type = block.getType();
    // const { page } = getProps();
    if (type === identifier) {
      return {
        component: TableEditor,
        editable: false,
        props: {
          editorState: getEditorState(),
          setEditorState,
          readOnly: getReadOnly(),
          dataRenderComponent,
          config,
          data,
          identifier,
        },
      };
    }
    return null;
  },
});

export default TableEditorFactory;
